import { useEffect } from "react";

/**
 * PagePrefetch Component
 * Prefetches critical routes after the initial page load to enable near-instant navigation
 * Uses Vike's prefetchRoute API for client-side prefetching
 */
const PagePrefetch = () => {
  useEffect(() => {
    // Only run on client-side
    if (typeof window === "undefined") return;

    // Prefetch after initial render to avoid blocking
    const prefetchTimer = setTimeout(() => {
      prefetchCriticalRoutes();
    }, 2000);

    return () => clearTimeout(prefetchTimer);
  }, []);

  const prefetchCriticalRoutes = async () => {
    const criticalRoutes = ["/Dashboard", "/Board", "/AIStudio"];

    // Use requestIdleCallback if available, otherwise run immediately
    const prefetchFn = () => {
      criticalRoutes.forEach((route) => {
        // Use Vike's prefetchRoute if available
        if (window.__vike_router?.prefetch) {
          window.__vike_router.prefetch(route);
        }
      });
    };

    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(prefetchFn, { timeout: 5000 });
    } else {
      prefetchFn();
    }
  };

  return null;
};

export default PagePrefetch;
